import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  balance: {
    availableAmount: {
      amount: '0',
      currencyCode: 'EUR'
    },
    pendingAmount: {
      amount: '0',
      currencyCode: 'EUR'
    },
    uiState: UiState.Idle
  },
  invoices: {
    invoiceLines: [],
    startBalance: {
      amount: '',
      currencyCode: ''
    },
    endBalance: {
      amount: '',
      currencyCode: ''
    },
    startingDate: '',
    uiState: UiState.Idle,
    history: undefined
  }
};

const getBalanceRequest = draft => {
  draft.balance.uiState = UiState.Pending;
};

const getBalanceFailure = draft => {
  draft.balance.uiState = UiState.Failure;
};

const getBalanceSuccess = (draft, action) => {
  const {
    balance
  } = action.payload;
  draft.balance = _objectSpread(_objectSpread({}, balance), {}, {
    uiState: UiState.Success
  });
};

const getCurrentInvoicesRequest = draft => {
  draft.invoices.uiState = UiState.Pending;
};

const getCurrentInvoicesFailure = draft => {
  draft.invoices.uiState = UiState.Failure;
};

const getCurrentInvoicesSuccess = (draft, action) => {
  const {
    invoices
  } = action.payload;
  draft.invoices = _objectSpread(_objectSpread({}, invoices), {}, {
    uiState: UiState.Success
  });
};

const getHistoricalInvoicesRequest = draft => {
  draft.invoices.uiState = UiState.Pending;
};

const getHistoricalInvoicesFailure = draft => {
  draft.invoices.uiState = UiState.Failure;
};

const getHistoricalInvoicesSuccess = (draft, action) => {
  const {
    invoices
  } = action.payload;
  draft.invoices = _objectSpread(_objectSpread({}, invoices), {}, {
    uiState: UiState.Success
  });
};

const walletSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    getBalanceRequest,
    getBalanceSuccess,
    getBalanceFailure,
    getCurrentInvoicesRequest,
    getCurrentInvoicesSuccess,
    getCurrentInvoicesFailure,
    getHistoricalInvoicesRequest,
    getHistoricalInvoicesFailure,
    getHistoricalInvoicesSuccess
  }
});
export const {
  actions
} = walletSlice;
export const plug = {
  [stateName]: walletSlice.reducer
};
export default walletSlice.reducer;